import axios from 'axios';
import { USER_SERVICE_URL, USER_SERVICE_TOKEN_URL } from '../../config/env';
import AuthActions from "@/store/actions/auth";

export default class AuthService {

    static getAuthToken(username:string, password:string){
      let formData = new FormData();
      formData.append('grant_type', 'password');
      formData.append('username', username);
      formData.append('password', password);

      return axios({
          method:'post',
          url: USER_SERVICE_TOKEN_URL,
          auth: {
              username: 'HoldWip',
              password: 'FkT=798sANku=3D3'
          },
          data: formData
      })
      .then(function (response) {
            const token = response.data['access_token'];
            localStorage.setItem('user-token', token);
            axios.defaults.headers.common.Authorization = 'Bearer ' + token;
            return response.data;
        })
        .catch( (error) => {
            throw error;
        });
    }

    static getUserProfile(){
        const applicationName = 'HoldWip';
        return axios({
            method: 'get',
            url: USER_SERVICE_URL + '/profile/' + applicationName,
        }).then((response)=>{
            return response
        }).catch((error)=>{
        })
    }
 }
